export default "__VITE_ASSET__BCgsZinq__"